// @flow
import { Fragment, type Node } from 'react';
import styled from '@emotion/styled';
import { typography, SPACING } from '@tablekit/theme';
import { createHeader } from '@tablekit/typography';
import Button from '@tablekit/button';
import Link from 'components/Link';
import RichText from 'components/RichText';
import type { DocType, UrlType } from 'components/types';
import Title from 'styled/Title';

type PropsType = {
  callToAction: ?UrlType,
  callToActionText: ?string,
  children: Node,
  description: ?DocType,
  subTitle: ?string,
  title: ?string,
  useCarousel: boolean
};

const CTAButtonWrapper = styled.div`
  margin-top: ${SPACING.L6};
  display: flex;
  flex-direction: row;
  justify-content: center;

  @media (min-width: 768px) {
    justify-content: flex-start;
  }
`;

const StaticCTAButtonWrapper = styled(CTAButtonWrapper)`
  justify-content: center;
  margin-top: ${SPACING.L6};
`;

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: stretch;
  margin: ${SPACING.L6} 0 0;
`;

const StaticTitle = styled(createHeader('h3', 'L7'))`
  margin-top: ${SPACING.L2};
`;

const StaticDescription = styled(RichText)`
  margin-top: ${SPACING.L2};
  ${typography('L4')};
  text-align: center;
  @media (min-width: 576px) {
    ${typography('L3')};
  }
  @media (min-width: 768px) {
    ${typography('L6')};
  }
`;

export default function CardsTemplate({
  useCarousel,
  title,
  subTitle,
  description: dataDescription,
  children,
  callToAction,
  callToActionText
}: PropsType) {
  let description;
  if (
    dataDescription &&
    dataDescription.content.length &&
    (dataDescription.content[0].text ||
      (dataDescription.content[0].content &&
        dataDescription.content[0].content.length))
  ) {
    description = dataDescription;
  }
  const postCarouselContent = (
    <Fragment>
      {subTitle && <StaticTitle>{subTitle}</StaticTitle>}
      {description && <StaticDescription richText={description} />}
      {callToAction && (callToAction.url || callToAction.cached_url) && (
        <StaticCTAButtonWrapper>
          <Button
            component={Link}
            gaReference={`Cards; ${title || 'CTA Icon'}`}
            link={callToAction}
          >
            {callToActionText || 'CTA Icon'}
          </Button>
        </StaticCTAButtonWrapper>
      )}
    </Fragment>
  );
  return (
    <Wrapper>
      {!useCarousel && title && <Title align="center">{title}</Title>}
      {children}
      {postCarouselContent}
    </Wrapper>
  );
}
